import { useCallback } from 'react';
import { useAccessibilityEnhanced } from './useAccessibilityEnhanced';

/**
 * Announces mode changes for screen reader users.
 * Uses aria-live polite via useAccessibilityEnhanced.
 */
export function useModeAnnouncement() {
  const { announceToScreenReader } = useAccessibilityEnhanced({ announcePageChange: false });

  const announceMode = useCallback((mode: string) => {
    const message = mode === 'Modalità Spesa'
      ? 'Modalità Spesa attivata'
      : 'Modalità Prepara attivata';
    announceToScreenReader(message);
  }, [announceToScreenReader]);

  return { announceMode };
}
